import React, { Component } from 'react';
import pickBy from 'lodash/pickBy';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { createQueryString, parseQueryParams } from '../../../utils/queryStringUtils';
import { toolingLocationListRoute } from '../../../config/navigation/routes';
import { forwardTo } from '../../../utils/browserHistoryUtils';
import logService from '../../../graphql/logging';

export default function ToolingLocationsSearch(ToolingPage) {
  class WrappedComponent extends Component {
    static propTypes = {
      location: PropTypes.object.isRequired,
      auth: PropTypes.object.isRequired,
    };

    // static initialValues = {};

    static initialState = {
      reset: false,
      searchTypeIsT: false,
      sohGreaterThan0: false,
      searchTypeIsP: false,
      toolFilter: undefined,
      // formValues: {},
      initialValues: {},
      disableSearchButtons: false,
      // page: 0,
      // pageSize: 20,
      // sorted: [],
    };

    state = WrappedComponent.initialState;

    async componentDidMount() {
      // console.log("did mount")
      const location = this.props.location;

      // If there is a query string (the user is coming to this page from a link)
      if (location.search) {
        this.searchFromQueryString();
      }
    }

    // /* ----------------------------------
    //   LIFECYCLE - COMPONENT DID UPDATE
    // -------------------------------------*/
    async componentDidUpdate(prevProps) {
      // If the reset has been hit, do not call the search again, and just turn the flag back to false.
      if (prevProps.location.search !== this.props.location.search && !this.state.reset) {
        await this.searchFromQueryString();
      } else if (this.state.reset) {
        this.toggleReset();
      }
    }

    // componentWillUnmount() {
    //   WrappedComponent.initialValues = {};
    // }

    toggleReset = () => {
      this.setState({ reset: !this.state.reset });
    };

    // remove the setstate from this function. It is taken care of in the putQueryStringInUrl, searchFromQueryString combo. This may lead to duplicate calls on state update of searchTypeIsP.
    // toggleFilterCriteria = (value, criterion) => {
    //   console.log("toggleFilterCriteria", value, criterion)
    //   if (value) {
    //     if (criterion === "searchTypeIsP") {
    //       this.setState({
    //         [criterion]: value,
    //         searchTypeIsT: false,
    //         sohGreaterThan0: false
    //       }, () => {
    //         this.putQueryStringInUrl(this.state.formValues, this.state.searchTypeIsT, this.state.sohGreaterThan0, this.state.searchTypeIsP)
    //       });
    //     }
    //     else {
    //       this.setState({
    //         [criterion]: value,
    //         searchTypeIsP: false
    //       }, () => {
    //         this.putQueryStringInUrl(this.state.formValues, this.state.searchTypeIsT, this.state.sohGreaterThan0, this.state.searchTypeIsP)
    //       });
    //     }
    //   } else {
    //     this.setState({
    //       [criterion]: value
    //     }, () => {
    //       this.putQueryStringInUrl(this.state.formValues, this.state.searchTypeIsT, this.state.sohGreaterThan0, this.state.searchTypeIsP)
    //     });
    //   }

    // }
    toggleFilterCriteria = (value, criterion) => {
      console.log("toggleFilterCriteria", value, criterion);
      const togglesvalues = {};
      let initialValues = this.state.initialValues;
      if (value) {
        if (criterion === "searchTypeIsP") {
          togglesvalues.searchTypeIsP = true;
          togglesvalues.searchTypeIsT = false;
          togglesvalues.sohGreaterThan0 = false;
          initialValues = {
            niin: this.state.initialValues.niin,
            searchCage: this.state.initialValues.searchCage
          }
        }
        else {
          togglesvalues.searchTypeIsP = false;
          togglesvalues.searchTypeIsT = this.state.searchTypeIsT;
          togglesvalues.sohGreaterThan0 = this.state.sohGreaterThan0;
          togglesvalues[criterion] = value;
        }
      } else {
        togglesvalues.searchTypeIsP = this.state.searchTypeIsP;
        togglesvalues.searchTypeIsT = this.state.searchTypeIsT;
        togglesvalues.sohGreaterThan0 = this.state.sohGreaterThan0;
        togglesvalues[criterion] = value;
      }
      console.log("criterion", togglesvalues[criterion])
      this.putQueryStringInUrl(initialValues, togglesvalues.searchTypeIsT, togglesvalues.sohGreaterThan0, togglesvalues.searchTypeIsP)
    }

    _onChangeField = (value, fieldname) => {
      console.log(" field change", fieldname, value)
      if (value === "") {
        this.setState(prevState => ({
          initialValues: {
            ...Object.keys(prevState.initialValues).filter(key =>
              key !== fieldname).reduce((acc, key) => ({
                ...acc,
                [key]: prevState.initialValues[key]
              }), {}
              )
          }
        }))
        // this.setState({
        //   initialValues: {}
        // })
      } else {
        this.setState({
          initialValues: {
            [fieldname]: value
          }
        })
      }
    }

    updateDisableSearchButtons = (value) => {
      this.setState({
        disableSearchButtons: value
      })
    }

    searchFromQueryString = async () => {
      const location = this.props.location;
      const queryParams = parseQueryParams(location);
      const partNum = queryParams.partNum;
      const description = queryParams.description;
      const niin = queryParams.niin;
      const wsdc = queryParams.wsdc;
      const wsName = queryParams.wsName;
      const searchCage = queryParams.searchCage;
      const solicitation = queryParams.solicitation;
      // const sorted = queryParams.sorted;
      // const page = queryParams.page;
      // const pageSize = queryParams.pageSize;
      const searchTypeIsT = queryParams.searchTypeIsT;
      const sohGreaterThan0 = queryParams.sohGreaterThan0;
      const searchTypeIsP = queryParams.searchTypeIsP;
      console.log("searchFromQueryString", queryParams)


      // const url = `${toolingLocationListRoute}?${createQueryString({
      //   description,
      //   niin,
      //   partNum,
      //   wsdc,
      //   wsName,
      //   searchCage,
      //   solicitation,
      // })}`;
      const initialValues = {
        description,
        niin,
        partNum,
        wsdc,
        wsName,
        searchCage,
        solicitation,
      };
      // forwardTo(url);

      let toolFilter = []
      // const queryParamsNormalized = pickBy(queryParams, obj => obj); // this eliminates KVP with null value

      const initialValuesNormalized = pickBy(initialValues, obj => obj); // this eliminates KVP with null value

      Object.keys(initialValuesNormalized)
        .forEach((key) => {
          // if (key !== "sorted" && key !== "page" && key !== "pageSize" && key !== "searchTypeIsT" && key !== "sohGreaterThan0") {
          const item = {
            field: key,
            value: initialValuesNormalized[key]
          }
          toolFilter.push(item);
          // }
        });

      if (toolFilter.length > 0 && searchTypeIsT) {
        const item = {
          field: "searchType",
          value: "T"
        };
        toolFilter.push(item);
      }
      if (toolFilter.length > 0 && sohGreaterThan0) {
        const item = {
          field: "soh",
          value: 0
        };
        toolFilter.push(item);
      }
      if (toolFilter.length > 0 && searchTypeIsP && !searchTypeIsT) {
        const item = {
          field: "searchType",
          value: "P"
        };
        toolFilter.push(item);
      }
      if (toolFilter.length === 0) {
        toolFilter = undefined;
      }

      this.setState({
        toolFilter,
        initialValues: initialValuesNormalized,
        // sorted: JSON.parse(sorted) || [],
        // page: page || 0,
        // pageSize: pageSize || 20,
        searchTypeIsT,
        sohGreaterThan0,
        searchTypeIsP,
      });

      if (toolFilter) {
        const postLogsBody = {
          level: 'info',
          message: `Tooling locations search submited for user with cage: ${this.props.auth.cageCode} and email: ${this.props.auth.email} and search criteria: ${JSON.stringify(queryParams)} `,
          className: 'ToolingLocations',
          methodName: 'SubmitSearch',
        };
        logService(postLogsBody).then((res) => {
          console.log('------axios---function searchFromQueryString----->', res);
        }).catch((err) => {
          console.error({ msg: 'Error Unable to send logs to DB2!', postLogsBody }, err);
        });
      }

    };

    // putQueryStringInUrl = (queryParams, sorted, page, pageSize, searchTypeIsT, sohGreaterThan0) => {
    putQueryStringInUrl = (queryParams, searchTypeIsT, sohGreaterThan0, searchTypeIsP) => {
      const description = queryParams.description;
      const niin = queryParams.niin;
      const partNum = queryParams.partNum;
      const wsdc = queryParams.wsdc;
      const wsName = queryParams.wsName;
      const searchCage = queryParams.searchCage;
      const solicitation = queryParams.solicitation;

      const url = `${toolingLocationListRoute}?${createQueryString({
        description,
        niin,
        partNum,
        wsdc,
        wsName,
        searchCage,
        solicitation,
        // sorted: JSON.stringify(sorted),
        // page,
        // pageSize,
        searchTypeIsT,
        sohGreaterThan0,
        searchTypeIsP
      })}`;
      localStorage.setItem('toolingSearchURL', url);
      // WrappedComponent.initialValues = {
      //   description,
      //   niin,
      //   partNum,
      //   wsdc,
      //   wsName,
      //   searchCage,
      //   solicitation,
      // };
      forwardTo(url);
    };

    search = async formValues => {
      const queryParams = pickBy(formValues, obj => obj); // this eliminates KVP with null value
      // this.setState({
      //   formValues: queryParams,
      // });
      // this.putQueryStringInUrl(queryParams, this.state.sorted, this.state.page, this.state.pageSize, this.state.searchTypeIsT, this.state.sohGreaterThan0);
      this.putQueryStringInUrl(queryParams, this.state.searchTypeIsT, this.state.sohGreaterThan0, this.state.searchTypeIsP);
    }

    _resetSearch = () => {
      this.setState({
        reset: true,
        toolFilter: undefined,
        // sorted: [],
        // page: 0,
        // pageSize: 20,
        searchTypeIsT: false,
        sohGreaterThan0: false,
        searchTypeIsP: false,
        initialValues: {}
      });
      this.putQueryStringInUrl({});
      localStorage.removeItem('toolingSearchURL');
      // WrappedComponent.initialValues = {};
    };

    render() {
      // const { searchTypeIsT, sohGreaterThan0, toolFilter, sorted, page, pageSize } = this.state;
      const { searchTypeIsT, sohGreaterThan0, searchTypeIsP, toolFilter, initialValues, disableSearchButtons } = this.state;
      return (
        <ToolingPage
          handleSubmit={this.search}
          searchReset={this._resetSearch}
          auth={this.props.auth}
          searchTypeIsT={searchTypeIsT}
          sohGreaterThan0={sohGreaterThan0}
          searchTypeIsP={searchTypeIsP}
          toolFilter={toolFilter}
          toggleFilterCriteria={this.toggleFilterCriteria}
          initialValues={initialValues}

          onChangeField={this._onChangeField}
          disableSearchButtons={disableSearchButtons}
          updateDisableSearchButtons={this.updateDisableSearchButtons}
        // sorted={sorted}
        // page={page}
        // pageSize={pageSize}

        />
      );
    }
  }
  return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/components/ToolingLocations/ToolingLocationsSearch/ToolingLocationSearchHOC.jsx